import { configs } from 'configuration';
import { KoAPI } from "packages";
const version = configs().API_VERSION;
export const FilesAPI = {
  getFolders(query) {
    return KoAPI.get(`/api/${version}/file/folder`, { query: { ...query } });
  },
  getFoldersById(id, query) {
    return KoAPI.get(`/api/${version}/file/folder/${id}`, { query: { ...query } });
  },
  linkToWorkspace(id, data){
    return KoAPI.update(`/api/${version}/file/update/project/${id}`, {data});
  },
  getFoldersStarred(query) {
    return KoAPI.get(`/api/${version}/file/folder/starred`, { query: { ...query } });
  },
  getSharedFolders(query) {
    return KoAPI.get(`/api/${version}/file/folder/shared`, { query: { ...query } });
  },
  starredDocument(data){
    return KoAPI.update(`/api/${version}/file/starred`, {data});
  },
  getFolderById(id) {
    return KoAPI.get(`/api/${version}/file/folder/${id}`);
  },
  getBinFolders() {
    return KoAPI.get(`/api/${version}/file/bin/folder`);
  },
  fileShare(data){
    return KoAPI.update(`/api/${version}/file/share`, { data});
  },
  createOrUpdateFolder(data, id){
    if(id){
      return KoAPI.update(`/api/${version}/file/folder/${id}`, { data});
    }else{
      return KoAPI.post(`/api/${version}/file/folder`, { data});
    }
  },
  getDocuments(query={}, folderId){
    if(folderId){
      query.folderId = folderId;
    }
    return KoAPI.get(`/api/${version}/file/all/files`, { query: { ...query } });
  },
  getDocumentsRecent(query, folderId){
    if(folderId){
      query.folderId = folderId;
    }
    return KoAPI.get(`/api/${version}/file/recent/files`, { query: { ...query } });
  },
  getSharedDocuments(query, folderId){
    if(folderId){
      query.folderId = folderId;
    }
    return KoAPI.get(`/api/${version}/file/shared`, { query: { ...query } });
   
  },
  deleteFolderById(folderId){
    return KoAPI.delete(`/api/${version}/file/folder/${folderId}`);
  },
  deleteFolderByIdTrash(folderId){
    return KoAPI.delete(`/api/${version}/file/folder/remove/${folderId}`);
  },
  uploadFile(folderId, data){
    return KoAPI.post(`/api/${version}/file/${folderId}/file/upload`, { data});
  },

  getUpload(data){
    return KoAPI.post(`/api/${version}/upload/read`, { data: { ...data } });
  },

  getRecentFiles(query, folderId){
    return KoAPI.get(`/api/${version}/file/recent`, { query: { ...query } });
  },
  getBinDocuments(query, folderId){
    if(folderId){
      query.folderId = folderId;
    }
    return KoAPI.get(`/api/${version}/file/bin`, { query: { ...query } });
  },
  getFile(url, query){
    return KoAPI.get(url, { query: { ...query } });
  },
  getFileById(id, query){
    return KoAPI.get(`/api/${version}/file/${id}`, { query: { ...query }});
  },
  getFilJSON(url){
    return KoAPI.getURL(`${url}`);
  },

  getFilesByFolderId(folderId){
    return KoAPI.get(`/api/${version}/file/${folderId}/file`);
  },
  moveDocumentToFolder(data, fid){
    let query={};
    if(fid){
      query['folderId']= fid;
    }
    return KoAPI.update(`/api/${version}/file/move`, {data, query: { ...query } });
  },
  createOrUpdateFile(data, id, query) {
    if(id && id!=='new' && id!=='whiteboard'){
      return KoAPI.update(`/api/${version}/file/${id}`,  { data, query: { ...query } });
    }else{
      return KoAPI.post(`/api/${version}/file/new`, { data, query: { ...query } });
    }
  },
  renameDocument(data, id){
    return KoAPI.update(`/api/${version}/file/rename/${id}`, {data});
  },
  deleteDocumentById(data, query){
    return KoAPI.delete(`/api/${version}/file/remove`, {data, query: { ...query } });
  },

  deleteDocumentByIdPermanently(data, query){
    return KoAPI.delete(`/api/${version}/file/remove/permanently`, {data, query: { ...query } });
  },
  restoreDocument(data, query){
    return KoAPI.update(`/api/${version}/file/restore`, {data, query: { ...query } });
  },
  removeFileAccess(data, folderId){
    let query={};
    if(folderId){
      query['folderId']= folderId;
    }
    return KoAPI.update(`/api/${version}/file/remove/access`, {data, query: { ...query } });
  },
  createReaction(documentId, id, data) {
    return KoAPI.update(`/api/${version}/comments/reaction/${documentId}/${id}`, { data});
  },
  getComments(documentId){
    return KoAPI.get(`/api/${version}/comments/${documentId}`);
  },
  createComment(data, id){
    if(id){
      return KoAPI.update(`/api/${version}/comments/${data?.documentId}/${id}`, { data: { ...data }});
    }else{
      return KoAPI.post(`/api/${version}/comments/create`, { data: { ...data }});
    }
  },
  deleteComment(documentId, commentId){
    return KoAPI.delete(`/api/${version}/comments/${documentId}/${commentId}`);
  },
  getUsers(){
    return KoAPI.get(`/api/${version}/org/user`);
  },
  getGroups(){
    return KoAPI.get(`/api/${version}/org/group`);
  }

};